import { z } from 'zod';
import { isoDateTimeSchema, objectIdSchema } from './common.js';
/** Longueur minimale des mots de passe (`04` §6, `02` §1). */
export const PASSWORD_MIN_LENGTH = 12;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères`);
export const userListItemSchema = z.object({
    id: objectIdSchema,
    email: z.email(),
    name: z.string(),
    createdAt: isoDateTimeSchema,
    invitedAt: isoDateTimeSchema.nullable(),
    activatedAt: isoDateTimeSchema.nullable(),
    lastLoginAt: isoDateTimeSchema.nullable(),
    lockedUntil: isoDateTimeSchema.nullable(),
});
export const userInviteBodySchema = z.object({
    email: z.email(),
    name: z.string().min(1),
});
export const changePasswordBodySchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
//# sourceMappingURL=users.js.map